(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.cloudSenseAddOnDependencyEngine = factory());
}(this, (function () { 'use strict';

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  var _arrayEach = arrayEach;

  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }

  var _createBaseFor = createBaseFor;

  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = _createBaseFor();

  var _baseFor = baseFor;

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  var _baseTimes = baseTimes;

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  var _freeGlobal = freeGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = _freeGlobal || freeSelf || Function('return this')();

  var _root = root;

  /** Built-in value references. */
  var Symbol = _root.Symbol;

  var _Symbol = Symbol;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Built-in value references. */
  var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }

  var _getRawTag = getRawTag;

  /** Used for built-in method references. */
  var objectProto$1 = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString$1 = objectProto$1.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString$1.call(value);
  }

  var _objectToString = objectToString;

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag$1 && symToStringTag$1 in Object(value))
      ? _getRawTag(value)
      : _objectToString(value);
  }

  var _baseGetTag = baseGetTag;

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }

  var isObjectLike_1 = isObjectLike;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]';

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
  }

  var _baseIsArguments = baseIsArguments;

  /** Used for built-in method references. */
  var objectProto$2 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
    return isObjectLike_1(value) && hasOwnProperty$1.call(value, 'callee') &&
      !propertyIsEnumerable.call(value, 'callee');
  };

  var isArguments_1 = isArguments;

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  var isArray_1 = isArray;

  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  var stubFalse_1 = stubFalse;

  var isBuffer_1 = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports =  exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? _root.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse_1;

  module.exports = isBuffer;
  });

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;

    return !!length &&
      (type == 'number' ||
        (type != 'symbol' && reIsUint.test(value))) &&
          (value > -1 && value % 1 == 0 && value < length);
  }

  var _isIndex = isIndex;

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER$1 = 9007199254740991;

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' &&
      value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
  }

  var isLength_1 = isLength;

  /** `Object#toString` result references. */
  var argsTag$1 = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike_1(value) &&
      isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
  }

  var _baseIsTypedArray = baseIsTypedArray;

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  var _baseUnary = baseUnary;

  var _nodeUtil = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports =  exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && _freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  module.exports = nodeUtil;
  });

  /* Node.js helper references. */
  var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

  var isTypedArray_1 = isTypedArray;

  /** Used for built-in method references. */
  var objectProto$3 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray_1(value),
        isArg = !isArr && isArguments_1(value),
        isBuff = !isArr && !isArg && isBuffer_1(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? _baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty$2.call(value, key)) &&
          !(skipIndexes && (
             // Safari 9 has enumerable `arguments.length` in strict mode.
             key == 'length' ||
             // Node.js 0.10 has enumerable non-index properties on buffers.
             (isBuff && (key == 'offset' || key == 'parent')) ||
             // PhantomJS 2 has enumerable non-index properties on typed arrays.
             (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
             // Skip index properties.
             _isIndex(key, length)
          ))) {
        result.push(key);
      }
    }
    return result;
  }

  var _arrayLikeKeys = arrayLikeKeys;

  /** Used for built-in method references. */
  var objectProto$4 = Object.prototype;

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

    return value === proto;
  }

  var _isPrototype = isPrototype;

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  var _overArg = overArg;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = _overArg(Object.keys, Object);

  var _nativeKeys = nativeKeys;

  /** Used for built-in method references. */
  var objectProto$5 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    if (!_isPrototype(object)) {
      return _nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }
    return result;
  }

  var _baseKeys = baseKeys;

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }

  var isObject_1 = isObject;

  /** `Object#toString` result references. */
  var asyncTag = '[object AsyncFunction]',
      funcTag$1 = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject_1(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = _baseGetTag(value);
    return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  var isFunction_1 = isFunction;

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength_1(value.length) && !isFunction_1(value);
  }

  var isArrayLike_1 = isArrayLike;

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys(object) {
    return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
  }

  var keys_1 = keys;

  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */
  function baseForOwn(object, iteratee) {
    return object && _baseFor(object, iteratee, keys_1);
  }

  var _baseForOwn = baseForOwn;

  /**
   * Creates a `baseEach` or `baseEachRight` function.
   *
   * @private
   * @param {Function} eachFunc The function to iterate over a collection.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike_1(collection)) {
        return eachFunc(collection, iteratee);
      }
      var length = collection.length,
          index = fromRight ? length : -1,
          iterable = Object(collection);

      while ((fromRight ? index-- : ++index < length)) {
        if (iteratee(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }

  var _createBaseEach = createBaseEach;

  /**
   * The base implementation of `_.forEach` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   */
  var baseEach = _createBaseEach(_baseForOwn);

  var _baseEach = baseEach;

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  var identity_1 = identity;

  /**
   * Casts `value` to `identity` if it's not a function.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Function} Returns cast function.
   */
  function castFunction(value) {
    return typeof value == 'function' ? value : identity_1;
  }

  var _castFunction = castFunction;

  /**
   * Iterates over elements of `collection` and invokes `iteratee` for each element.
   * The iteratee is invoked with three arguments: (value, index|key, collection).
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * **Note:** As with other "Collections" methods, objects with a "length"
   * property are iterated like arrays. To avoid this behavior use `_.forIn`
   * or `_.forOwn` for object iteration.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @alias each
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   * @see _.forEachRight
   * @example
   *
   * _.forEach([1, 2], function(value) {
   *   console.log(value);
   * });
   * // => Logs `1` then `2`.
   *
   * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
   *   console.log(key);
   * });
   * // => Logs 'a' then 'b' (iteration order is not guaranteed).
   */
  function forEach(collection, iteratee) {
    var func = isArray_1(collection) ? _arrayEach : _baseEach;
    return func(collection, _castFunction(iteratee));
  }

  var forEach_1 = forEach;

  var each = forEach_1;

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  var _arrayFilter = arrayFilter;

  /**
   * The base implementation of `_.filter` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function baseFilter(collection, predicate) {
    var result = [];
    _baseEach(collection, function(value, index, collection) {
      if (predicate(value, index, collection)) {
        result.push(value);
      }
    });
    return result;
  }

  var _baseFilter = baseFilter;

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  var _listCacheClear = listCacheClear;

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || (value !== value && other !== other);
  }

  var eq_1 = eq;

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq_1(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  var _assocIndexOf = assocIndexOf;

  /** Used for built-in method references. */
  var arrayProto = Array.prototype;

  /** Built-in value references. */
  var splice = arrayProto.splice;

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
        index = _assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }

  var _listCacheDelete = listCacheDelete;

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
        index = _assocIndexOf(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  var _listCacheGet = listCacheGet;

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return _assocIndexOf(this.__data__, key) > -1;
  }

  var _listCacheHas = listCacheHas;

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
        index = _assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  var _listCacheSet = listCacheSet;

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = _listCacheClear;
  ListCache.prototype['delete'] = _listCacheDelete;
  ListCache.prototype.get = _listCacheGet;
  ListCache.prototype.has = _listCacheHas;
  ListCache.prototype.set = _listCacheSet;

  var _ListCache = ListCache;

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new _ListCache;
    this.size = 0;
  }

  var _stackClear = stackClear;

  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);

    this.size = data.size;
    return result;
  }

  var _stackDelete = stackDelete;

  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }

  var _stackGet = stackGet;

  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }

  var _stackHas = stackHas;

  /** Used to detect overreaching core-js shims. */
  var coreJsData = _root['__core-js_shared__'];

  var _coreJsData = coreJsData;

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = (function() {
    var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
  }());

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
  }

  var _isMasked = isMasked;

  /** Used for built-in method references. */
  var funcProto = Function.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return (func + '');
      } catch (e) {}
    }
    return '';
  }

  var _toSource = toSource;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used for built-in method references. */
  var funcProto$1 = Function.prototype,
      objectProto$6 = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString$1 = funcProto$1.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' +
    funcToString$1.call(hasOwnProperty$4).replace(reRegExpChar, '\\$&')
    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  );

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject_1(value) || _isMasked(value)) {
      return false;
    }
    var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
    return pattern.test(_toSource(value));
  }

  var _baseIsNative = baseIsNative;

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  var _getValue = getValue;

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = _getValue(object, key);
    return _baseIsNative(value) ? value : undefined;
  }

  var _getNative = getNative;

  /* Built-in method references that are verified to be native. */
  var Map = _getNative(_root, 'Map');

  var _Map = Map;

  /* Built-in method references that are verified to be native. */
  var nativeCreate = _getNative(Object, 'create');

  var _nativeCreate = nativeCreate;

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
    this.size = 0;
  }

  var _hashClear = hashClear;

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  var _hashDelete = hashDelete;

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used for built-in method references. */
  var objectProto$7 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (_nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty$5.call(data, key) ? data[key] : undefined;
  }

  var _hashGet = hashGet;

  /** Used for built-in method references. */
  var objectProto$8 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$6.call(data, key);
  }

  var _hashHas = hashHas;

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
    return this;
  }

  var _hashSet = hashSet;

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = _hashClear;
  Hash.prototype['delete'] = _hashDelete;
  Hash.prototype.get = _hashGet;
  Hash.prototype.has = _hashHas;
  Hash.prototype.set = _hashSet;

  var _Hash = Hash;

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new _Hash,
      'map': new (_Map || _ListCache),
      'string': new _Hash
    };
  }

  var _mapCacheClear = mapCacheClear;

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
      ? (value !== '__proto__')
      : (value === null);
  }

  var _isKeyable = isKeyable;

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return _isKeyable(key)
      ? data[typeof key == 'string' ? 'string' : 'hash']
      : data.map;
  }

  var _getMapData = getMapData;

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    var result = _getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  var _mapCacheDelete = mapCacheDelete;

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return _getMapData(this, key).get(key);
  }

  var _mapCacheGet = mapCacheGet;

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return _getMapData(this, key).has(key);
  }

  var _mapCacheHas = mapCacheHas;

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    var data = _getMapData(this, key),
        size = data.size;

    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  var _mapCacheSet = mapCacheSet;

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = _mapCacheClear;
  MapCache.prototype['delete'] = _mapCacheDelete;
  MapCache.prototype.get = _mapCacheGet;
  MapCache.prototype.has = _mapCacheHas;
  MapCache.prototype.set = _mapCacheSet;

  var _MapCache = MapCache;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof _ListCache) {
      var pairs = data.__data__;
      if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new _MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }

  var _stackSet = stackSet;

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    var data = this.__data__ = new _ListCache(entries);
    this.size = data.size;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = _stackClear;
  Stack.prototype['delete'] = _stackDelete;
  Stack.prototype.get = _stackGet;
  Stack.prototype.has = _stackHas;
  Stack.prototype.set = _stackSet;

  var _Stack = Stack;

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED$2);
    return this;
  }

  var _setCacheAdd = setCacheAdd;

  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */
  function setCacheHas(value) {
    return this.__data__.has(value);
  }

  var _setCacheHas = setCacheHas;

  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */
  function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new _MapCache;
    while (++index < length) {
      this.add(values[index]);
    }
  }

  // Add methods to `SetCache`.
  SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
  SetCache.prototype.has = _setCacheHas;

  var _SetCache = SetCache;

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  var _arraySome = arraySome;

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  var _cacheHas = cacheHas;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }
    var index = -1,
        result = true,
        seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

    stack.set(array, other);
    stack.set(other, array);

    // Ignore non-index properties.
    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial
          ? customizer(othValue, arrValue, index, other, array, stack)
          : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== undefined) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      // Recursively compare arrays (susceptible to call stack limits).
      if (seen) {
        if (!_arraySome(other, function(othValue, othIndex) {
              if (!_cacheHas(seen, othIndex) &&
                  (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
          result = false;
          break;
        }
      } else if (!(
            arrValue === othValue ||
              equalFunc(arrValue, othValue, bitmask, customizer, stack)
          )) {
        result = false;
        break;
      }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
  }

  var _equalArrays = equalArrays;

  /** Built-in value references. */
  var Uint8Array = _root.Uint8Array;

  var _Uint8Array = Uint8Array;

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  var _mapToArray = mapToArray;

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  var _setToArray = setToArray;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$1 = 1,
      COMPARE_UNORDERED_FLAG$1 = 2;

  /** `Object#toString` result references. */
  var boolTag$1 = '[object Boolean]',
      dateTag$1 = '[object Date]',
      errorTag$1 = '[object Error]',
      mapTag$1 = '[object Map]',
      numberTag$1 = '[object Number]',
      regexpTag$1 = '[object RegExp]',
      setTag$1 = '[object Set]',
      stringTag$1 = '[object String]',
      symbolTag = '[object Symbol]';

  var arrayBufferTag$1 = '[object ArrayBuffer]',
      dataViewTag$1 = '[object DataView]';

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = _Symbol ? _Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag$1:
        if ((object.byteLength != other.byteLength) ||
            (object.byteOffset != other.byteOffset)) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag$1:
        if ((object.byteLength != other.byteLength) ||
            !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
          return false;
        }
        return true;

      case boolTag$1:
      case dateTag$1:
      case numberTag$1:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq_1(+object, +other);

      case errorTag$1:
        return object.name == other.name && object.message == other.message;

      case regexpTag$1:
      case stringTag$1:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == (other + '');

      case mapTag$1:
        var convert = _mapToArray;

      case setTag$1:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
        convert || (convert = _setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        }
        // Assume cyclic values are equal.
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG$1;

        // Recursively compare objects (susceptible to call stack limits).
        stack.set(object, other);
        var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }

  var _equalByTag = equalByTag;

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  var _arrayPush = arrayPush;

  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
  }

  var _baseGetAllKeys = baseGetAllKeys;

  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */
  function stubArray() {
    return [];
  }

  var stubArray_1 = stubArray;

  /** Used for built-in method references. */
  var objectProto$9 = Object.prototype;

  /** Built-in value references. */
  var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeGetSymbols = Object.getOwnPropertySymbols;

  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return _arrayFilter(nativeGetSymbols(object), function(symbol) {
      return propertyIsEnumerable$1.call(object, symbol);
    });
  };

  var _getSymbols = getSymbols;

  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function getAllKeys(object) {
    return _baseGetAllKeys(object, keys_1, _getSymbols);
  }

  var _getAllKeys = getAllKeys;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$2 = 1;

  /** Used for built-in method references. */
  var objectProto$a = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$7 = objectProto$a.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
        objProps = _getAllKeys(object),
        objLength = objProps.length,
        othProps = _getAllKeys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty$7.call(other, key))) {
        return false;
      }
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);

    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial
          ? customizer(othValue, objValue, key, other, object, stack)
          : customizer(objValue, othValue, key, object, other, stack);
      }
      // Recursively compare objects (susceptible to call stack limits).
      if (!(compared === undefined
            ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
            : compared
          )) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor;

      // Non `Object` object instances with different constructors are not equal.
      if (objCtor != othCtor &&
          ('constructor' in object && 'constructor' in other) &&
          !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
            typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
  }

  var _equalObjects = equalObjects;

  /* Built-in method references that are verified to be native. */
  var DataView = _getNative(_root, 'DataView');

  var _DataView = DataView;

  /* Built-in method references that are verified to be native. */
  var Promise = _getNative(_root, 'Promise');

  var _Promise = Promise;

  /* Built-in method references that are verified to be native. */
  var Set$1 = _getNative(_root, 'Set');

  var _Set = Set$1;

  /* Built-in method references that are verified to be native. */
  var WeakMap = _getNative(_root, 'WeakMap');

  var _WeakMap = WeakMap;

  /** `Object#toString` result references. */
  var mapTag$2 = '[object Map]',
      objectTag$1 = '[object Object]',
      promiseTag = '[object Promise]',
      setTag$2 = '[object Set]',
      weakMapTag$1 = '[object WeakMap]';

  var dataViewTag$2 = '[object DataView]';

  /** Used to detect maps, sets, and weakmaps. */
  var dataViewCtorString = _toSource(_DataView),
      mapCtorString = _toSource(_Map),
      promiseCtorString = _toSource(_Promise),
      setCtorString = _toSource(_Set),
      weakMapCtorString = _toSource(_WeakMap);

  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  var getTag = _baseGetTag;

  // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
  if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
      (_Map && getTag(new _Map) != mapTag$2) ||
      (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
      (_Set && getTag(new _Set) != setTag$2) ||
      (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
    getTag = function(value) {
      var result = _baseGetTag(value),
          Ctor = result == objectTag$1 ? value.constructor : undefined,
          ctorString = Ctor ? _toSource(Ctor) : '';

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString: return dataViewTag$2;
          case mapCtorString: return mapTag$2;
          case promiseCtorString: return promiseTag;
          case setCtorString: return setTag$2;
          case weakMapCtorString: return weakMapTag$1;
        }
      }
      return result;
    };
  }

  var _getTag = getTag;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$3 = 1;

  /** `Object#toString` result references. */
  var argsTag$2 = '[object Arguments]',
      arrayTag$1 = '[object Array]',
      objectTag$2 = '[object Object]';

  /** Used for built-in method references. */
  var objectProto$b = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$8 = objectProto$b.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray_1(object),
        othIsArr = isArray_1(other),
        objTag = objIsArr ? arrayTag$1 : _getTag(object),
        othTag = othIsArr ? arrayTag$1 : _getTag(other);

    objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
    othTag = othTag == argsTag$2 ? objectTag$2 : othTag;

    var objIsObj = objTag == objectTag$2,
        othIsObj = othTag == objectTag$2,
        isSameTag = objTag == othTag;

    if (isSameTag && isBuffer_1(object)) {
      if (!isBuffer_1(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new _Stack);
      return (objIsArr || isTypedArray_1(object))
        ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
        : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
      var objIsWrapped = objIsObj && hasOwnProperty$8.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty$8.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;

        stack || (stack = new _Stack);
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new _Stack);
    return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }

  var _baseIsEqualDeep = baseIsEqualDeep;

  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
      return value !== value && other !== other;
    }
    return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }

  var _baseIsEqual = baseIsEqual;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$4 = 1,
      COMPARE_UNORDERED_FLAG$2 = 2;

  /**
   * The base implementation of `_.isMatch` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Object} source The object of property values to match.
   * @param {Array} matchData The property names, values, and compare flags to match.
   * @param {Function} [customizer] The function to customize comparisons.
   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
   */
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length,
        length = index,
        noCustomizer = !customizer;

    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if ((noCustomizer && data[2])
            ? data[1] !== object[data[0]]
            : !(data[0] in object)
          ) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0],
          objValue = object[key],
          srcValue = data[1];

      if (noCustomizer && data[2]) {
        if (objValue === undefined && !(key in object)) {
          return false;
        }
      } else {
        var stack = new _Stack;
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result === undefined
              ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
              : result
            )) {
          return false;
        }
      }
    }
    return true;
  }

  var _baseIsMatch = baseIsMatch;

  /**
   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` if suitable for strict
   *  equality comparisons, else `false`.
   */
  function isStrictComparable(value) {
    return value === value && !isObject_1(value);
  }

  var _isStrictComparable = isStrictComparable;

  /**
   * Gets the property names, values, and compare flags of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the match data of `object`.
   */
  function getMatchData(object) {
    var result = keys_1(object),
        length = result.length;

    while (length--) {
      var key = result[length],
          value = object[key];

      result[length] = [key, value, _isStrictComparable(value)];
    }
    return result;
  }

  var _getMatchData = getMatchData;

  /**
   * A specialized version of `matchesProperty` for source values suitable
   * for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function matchesStrictComparable(key, srcValue) {
    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue &&
        (srcValue !== undefined || (key in Object(object)));
    };
  }

  var _matchesStrictComparable = matchesStrictComparable;

  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatches(source) {
    var matchData = _getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function(object) {
      return object === source || _baseIsMatch(object, source, matchData);
    };
  }

  var _baseMatches = baseMatches;

  /** `Object#toString` result references. */
  var symbolTag$1 = '[object Symbol]';

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return typeof value == 'symbol' ||
      (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$1);
  }

  var isSymbol_1 = isSymbol;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/;

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey(value, object) {
    if (isArray_1(value)) {
      return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
        value == null || isSymbol_1(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object));
  }

  var _isKey = isKey;

  /** Error message constants. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `clear`, `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize(func, resolver) {
    if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };
    memoized.cache = new (memoize.Cache || _MapCache);
    return memoized;
  }

  // Expose `MapCache`.
  memoize.Cache = _MapCache;

  var memoize_1 = memoize;

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /**
   * A specialized version of `_.memoize` which clears the memoized function's
   * cache when it exceeds `MAX_MEMOIZE_SIZE`.
   *
   * @private
   * @param {Function} func The function to have its output memoized.
   * @returns {Function} Returns the new memoized function.
   */
  function memoizeCapped(func) {
    var result = memoize_1(func, function(key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });

    var cache = result.cache;
    return result;
  }

  var _memoizeCapped = memoizeCapped;

  /** Used to match property names within property paths. */
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath = _memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
    string.replace(rePropName, function(match, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
    });
    return result;
  });

  var _stringToPath = stringToPath;

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  var _arrayMap = arrayMap;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /** Used to convert symbols to primitives and strings. */
  var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
      symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isArray_1(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return _arrayMap(value, baseToString) + '';
    }
    if (isSymbol_1(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
  }

  var _baseToString = baseToString;

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    return value == null ? '' : _baseToString(value);
  }

  var toString_1 = toString;

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {Object} [object] The object to query keys on.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath(value, object) {
    if (isArray_1(value)) {
      return value;
    }
    return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
  }

  var _castPath = castPath;

  /** Used as references for various `Number` constants. */
  var INFINITY$1 = 1 / 0;

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey(value) {
    if (typeof value == 'string' || isSymbol_1(value)) {
      return value;
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
  }

  var _toKey = toKey;

  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */
  function baseGet(object, path) {
    path = _castPath(path, object);

    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[_toKey(path[index++])];
    }
    return (index && index == length) ? object : undefined;
  }

  var _baseGet = baseGet;

  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */
  function get(object, path, defaultValue) {
    var result = object == null ? undefined : _baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }

  var get_1 = get;

  /**
   * The base implementation of `_.hasIn` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }

  var _baseHasIn = baseHasIn;

  /**
   * Checks if `path` exists on `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @param {Function} hasFunc The function to check properties.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   */
  function hasPath(object, path, hasFunc) {
    path = _castPath(path, object);

    var index = -1,
        length = path.length,
        result = false;

    while (++index < length) {
      var key = _toKey(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result || ++index != length) {
      return result;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength_1(length) && _isIndex(key, length) &&
      (isArray_1(object) || isArguments_1(object));
  }

  var _hasPath = hasPath;

  /**
   * Checks if `path` is a direct or inherited property of `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.hasIn(object, 'a');
   * // => true
   *
   * _.hasIn(object, 'a.b');
   * // => true
   *
   * _.hasIn(object, ['a', 'b']);
   * // => true
   *
   * _.hasIn(object, 'b');
   * // => false
   */
  function hasIn(object, path) {
    return object != null && _hasPath(object, path, _baseHasIn);
  }

  var hasIn_1 = hasIn;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$5 = 1,
      COMPARE_UNORDERED_FLAG$3 = 2;

  /**
   * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
   *
   * @private
   * @param {string} path The path of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatchesProperty(path, srcValue) {
    if (_isKey(path) && _isStrictComparable(srcValue)) {
      return _matchesStrictComparable(_toKey(path), srcValue);
    }
    return function(object) {
      var objValue = get_1(object, path);
      return (objValue === undefined && objValue === srcValue)
        ? hasIn_1(object, path)
        : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
    };
  }

  var _baseMatchesProperty = baseMatchesProperty;

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  var _baseProperty = baseProperty;

  /**
   * A specialized version of `baseProperty` which supports deep paths.
   *
   * @private
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyDeep(path) {
    return function(object) {
      return _baseGet(object, path);
    };
  }

  var _basePropertyDeep = basePropertyDeep;

  /**
   * Creates a function that returns the value at `path` of a given object.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   * @example
   *
   * var objects = [
   *   { 'a': { 'b': 2 } },
   *   { 'a': { 'b': 1 } }
   * ];
   *
   * _.map(objects, _.property('a.b'));
   * // => [2, 1]
   *
   * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
   * // => [1, 2]
   */
  function property(path) {
    return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
  }

  var property_1 = property;

  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */
  function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
      return value;
    }
    if (value == null) {
      return identity_1;
    }
    if (typeof value == 'object') {
      return isArray_1(value)
        ? _baseMatchesProperty(value[0], value[1])
        : _baseMatches(value);
    }
    return property_1(value);
  }

  var _baseIteratee = baseIteratee;

  /**
   * Iterates over elements of `collection`, returning an array of all elements
   * `predicate` returns truthy for. The predicate is invoked with three
   * arguments: (value, index|key, collection).
   *
   * **Note:** Unlike `_.remove`, this method returns a new array.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   * @see _.reject
   * @example
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36, 'active': true },
   *   { 'user': 'fred',   'age': 40, 'active': false }
   * ];
   *
   * _.filter(users, function(o) { return !o.active; });
   * // => objects for ['fred']
   *
   * // The `_.matches` iteratee shorthand.
   * _.filter(users, { 'age': 36, 'active': true });
   * // => objects for ['barney']
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.filter(users, ['active', false]);
   * // => objects for ['fred']
   *
   * // The `_.property` iteratee shorthand.
   * _.filter(users, 'active');
   * // => objects for ['barney']
   *
   * // Combining several predicates using `_.overEvery` or `_.overSome`.
   * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
   * // => objects for ['fred', 'barney']
   */
  function filter(collection, predicate) {
    var func = isArray_1(collection) ? _arrayFilter : _baseFilter;
    return func(collection, _baseIteratee(predicate));
  }

  var filter_1 = filter;

  /**
   * The base implementation of `_.map` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function baseMap(collection, iteratee) {
    var index = -1,
        result = isArrayLike_1(collection) ? Array(collection.length) : [];

    _baseEach(collection, function(value, key, collection) {
      result[++index] = iteratee(value, key, collection);
    });
    return result;
  }

  var _baseMap = baseMap;

  /**
   * Creates an array of values by running each element in `collection` thru
   * `iteratee`. The iteratee is invoked with three arguments:
   * (value, index|key, collection).
   *
   * Many lodash methods are guarded to work as iteratees for methods like
   * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
   *
   * The guarded methods are:
   * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
   * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
   * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
   * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   * @example
   *
   * function square(n) {
   *   return n * n;
   * }
   *
   * _.map([4, 8], square);
   * // => [16, 64]
   *
   * _.map({ 'a': 4, 'b': 8 }, square);
   * // => [16, 64] (iteration order is not guaranteed)
   *
   * var users = [
   *   { 'user': 'barney' },
   *   { 'user': 'fred' }
   * ];
   *
   * // The `_.property` iteratee shorthand.
   * _.map(users, 'user');
   * // => ['barney', 'fred']
   */
  function map(collection, iteratee) {
    var func = isArray_1(collection) ? _arrayMap : _baseMap;
    return func(collection, _baseIteratee(iteratee));
  }

  var map_1 = map;

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  var _baseFindIndex = baseFindIndex;

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  var _baseIsNaN = baseIsNaN;

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  var _strictIndexOf = strictIndexOf;

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? _strictIndexOf(array, value, fromIndex)
      : _baseFindIndex(array, _baseIsNaN, fromIndex);
  }

  var _baseIndexOf = baseIndexOf;

  /** `Object#toString` result references. */
  var stringTag$2 = '[object String]';

  /**
   * Checks if `value` is classified as a `String` primitive or object.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a string, else `false`.
   * @example
   *
   * _.isString('abc');
   * // => true
   *
   * _.isString(1);
   * // => false
   */
  function isString(value) {
    return typeof value == 'string' ||
      (!isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag$2);
  }

  var isString_1 = isString;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  var _trimmedEndIndex = trimmedEndIndex;

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  var _baseTrim = baseTrim;

  /** Used as references for various `Number` constants. */
  var NAN = 0 / 0;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Built-in method references without a dependency on `root`. */
  var freeParseInt = parseInt;

  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */
  function toNumber(value) {
    if (typeof value == 'number') {
      return value;
    }
    if (isSymbol_1(value)) {
      return NAN;
    }
    if (isObject_1(value)) {
      var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
      value = isObject_1(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }
    value = _baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return (isBinary || reIsOctal.test(value))
      ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
      : (reIsBadHex.test(value) ? NAN : +value);
  }

  var toNumber_1 = toNumber;

  /** Used as references for various `Number` constants. */
  var INFINITY$2 = 1 / 0,
      MAX_INTEGER = 1.7976931348623157e+308;

  /**
   * Converts `value` to a finite number.
   *
   * @static
   * @memberOf _
   * @since 4.12.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted number.
   * @example
   *
   * _.toFinite(3.2);
   * // => 3.2
   *
   * _.toFinite(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toFinite(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toFinite('3.2');
   * // => 3.2
   */
  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }
    value = toNumber_1(value);
    if (value === INFINITY$2 || value === -INFINITY$2) {
      var sign = (value < 0 ? -1 : 1);
      return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
  }

  var toFinite_1 = toFinite;

  /**
   * Converts `value` to an integer.
   *
   * **Note:** This method is loosely based on
   * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted integer.
   * @example
   *
   * _.toInteger(3.2);
   * // => 3
   *
   * _.toInteger(Number.MIN_VALUE);
   * // => 0
   *
   * _.toInteger(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toInteger('3.2');
   * // => 3
   */
  function toInteger(value) {
    var result = toFinite_1(value),
        remainder = result % 1;

    return result === result ? (remainder ? result - remainder : result) : 0;
  }

  var toInteger_1 = toInteger;

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return _arrayMap(props, function(key) {
      return object[key];
    });
  }

  var _baseValues = baseValues;

  /**
   * Creates an array of the own enumerable string keyed property values of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property values.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.values(new Foo);
   * // => [1, 2] (iteration order is not guaranteed)
   *
   * _.values('hi');
   * // => ['h', 'i']
   */
  function values(object) {
    return object == null ? [] : _baseValues(object, keys_1(object));
  }

  var values_1 = values;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax = Math.max;

  /**
   * Checks if `value` is in `collection`. If `collection` is a string, it's
   * checked for a substring of `value`, otherwise
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * is used for equality comparisons. If `fromIndex` is negative, it's used as
   * the offset from the end of `collection`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object|string} collection The collection to inspect.
   * @param {*} value The value to search for.
   * @param {number} [fromIndex=0] The index to search from.
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
   * @returns {boolean} Returns `true` if `value` is found, else `false`.
   * @example
   *
   * _.includes([1, 2, 3], 1);
   * // => true
   *
   * _.includes([1, 2, 3], 1, 2);
   * // => false
   *
   * _.includes({ 'a': 1, 'b': 2 }, 1);
   * // => true
   *
   * _.includes('abcd', 'bc');
   * // => true
   */
  function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike_1(collection) ? collection : values_1(collection);
    fromIndex = (fromIndex && !guard) ? toInteger_1(fromIndex) : 0;

    var length = collection.length;
    if (fromIndex < 0) {
      fromIndex = nativeMax(length + fromIndex, 0);
    }
    return isString_1(collection)
      ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
      : (!!length && _baseIndexOf(collection, value, fromIndex) > -1);
  }

  var includes_1 = includes;

  /**
   * The inverse of `_.toPairs`; this method returns an object composed
   * from key-value `pairs`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Array
   * @param {Array} pairs The key-value pairs.
   * @returns {Object} Returns the new object.
   * @example
   *
   * _.fromPairs([['a', 1], ['b', 2]]);
   * // => { 'a': 1, 'b': 2 }
   */
  function fromPairs(pairs) {
    var index = -1,
        length = pairs == null ? 0 : pairs.length,
        result = {};

    while (++index < length) {
      var pair = pairs[index];
      result[pair[0]] = pair[1];
    }
    return result;
  }

  var fromPairs_1 = fromPairs;

  /** `Object#toString` result references. */
  var mapTag$3 = '[object Map]',
      setTag$3 = '[object Set]';

  /** Used for built-in method references. */
  var objectProto$c = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

  /**
   * Checks if `value` is an empty object, collection, map, or set.
   *
   * Objects are considered empty if they have no own enumerable string keyed
   * properties.
   *
   * Array-like values such as `arguments` objects, arrays, buffers, strings, or
   * jQuery-like collections are considered empty if they have a `length` of `0`.
   * Similarly, maps and sets are considered empty if they have a `size` of `0`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is empty, else `false`.
   * @example
   *
   * _.isEmpty(null);
   * // => true
   *
   * _.isEmpty(true);
   * // => true
   *
   * _.isEmpty(1);
   * // => true
   *
   * _.isEmpty([1, 2, 3]);
   * // => false
   *
   * _.isEmpty({ 'a': 1 });
   * // => false
   */
  function isEmpty(value) {
    if (value == null) {
      return true;
    }
    if (isArrayLike_1(value) &&
        (isArray_1(value) || typeof value == 'string' || typeof value.splice == 'function' ||
          isBuffer_1(value) || isTypedArray_1(value) || isArguments_1(value))) {
      return !value.length;
    }
    var tag = _getTag(value);
    if (tag == mapTag$3 || tag == setTag$3) {
      return !value.size;
    }
    if (_isPrototype(value)) {
      return !_baseKeys(value).length;
    }
    for (var key in value) {
      if (hasOwnProperty$9.call(value, key)) {
        return false;
      }
    }
    return true;
  }

  var isEmpty_1 = isEmpty;

  function remove(arr, predicate) {
    arr.forEach(function (ele, i) {
      if (predicate(ele)) {
        arr.splice(i, 1);
      }
    });
  }
  /* eslint-disable */
  // :) too much red ATM


  function buildAddOnManagerFunctions() {
    var groupMinMaxValidation = {};
    var allDependencyRecordsCached = [];
    var commercialProductAddOnAssociationListCached = [];
    var mapAssocIdAssocRecord = {};
    var currentCommercialProductId = '';
    var currentCommercialProductIdDetails = {};
    var currentCampaignPromotionSelId = '';
    var cachedDependencyData = {};
    var useDependencyEngine = false;
    var usedAutomaticInclusions = [];
    var usedAutomaticDeletions = [];
    /*
    * init
    *
    * Initializes the following data used by the Add On Manager:
    * current commercial product id, commercial product add on associations list and map and
    * add on dependency records.
    *
    * Input parameters are: commercial product id,Campaign Promotion ID, commercial product add on associations and
    * add on dependency records.
    */

    /*
    * ServiceFee --Added priceItemList argument in init
    * priceItemList: list of commercialProductIds i.e sf object id of source and target
    */

    function init(commercialProductId, campaignPromotionIDSelected, associationRecords, allDependencyRecords, isMACD, useDependencyEngineFlag, priceItemList) {
      useDependencyEngine = useDependencyEngineFlag;
      currentCommercialProductId = commercialProductId;
      currentCommercialProductIdDetails = priceItemList; //ServiceFee

      currentCampaignPromotionSelId = campaignPromotionIDSelected;
      mapAssocIdAssocRecord = {};
      commercialProductAddOnAssociationListCached = [];
      each(associationRecords, function (assoc) {
        assoc = Object.keys(assoc).reduce(function (c, k) {
          return c[k.toLowerCase()] = assoc[k], c;
        }, {});
        commercialProductAddOnAssociationListCached.push(assoc);
        mapAssocIdAssocRecord[assoc.id] = assoc;
      });
      each(allDependencyRecords, function (depRec) {
        depRec = Object.keys(depRec).reduce(function (c, k) {
          return c[k.toLowerCase()] = depRec[k], c;
        }, {});
        if (!allDependencyRecordsCached.some(function (dependencyrecord) {
          return dependencyrecord.name === depRec.name;
        })) allDependencyRecordsCached.push(depRec);
      }); //allDependencyRecordsCached = allDependencyRecords;

      usedAutomaticInclusions = [];
      usedAutomaticDeletions = [];

      if (isMACD !== undefined && useDependencyEngine) {
        allDependencyRecordsCached = filter_1(allDependencyRecordsCached, function (dependencyItem) {
          if (isMACD && dependencyItem.order_type__c === 'MACD' || !isMACD && dependencyItem.order_type__c === 'New Order' || dependencyItem.order_type__c === '' || dependencyItem.order_type__c === undefined) {
            return true;
          }

          return false;
        });
      }
    }
    /*
    * getCurrentCommercialProductId
    *
    * Returns the id of the commercial product currently set in the Add On Manager.
    */


    function getCurrentCommercialProductId() {
      return currentCommercialProductId;
    }
    /*ServiceFee
    * getCurrentCommercialProductDetails
    *
    * Returns the Details(Product Definition name and Subtype) of the commercial product currently set in the Add On Manager.
    */


    function getCurrentCommercialProductDetails() {
      return currentCommercialProductIdDetails;
    }
    /*
    * getCurrentCommercialProductId
    *
    * Returns the id of the campaign promotion currently set in the Add On Manager.
    */


    function getCurrentCampaignPromotionId() {
      return currentCampaignPromotionSelId;
    }
    /*
    * getCurrentCommercialProductId
    *
    * sets the id of the campaign promotion currently set in the Add On Manager.
    */


    function setCurrentCampaignPromotionId(campaignPromotionID) {
      currentCampaignPromotionSelId = campaignPromotionID;
    }
    /*
    * prepareDependencyMapsForCommercialProduct
    *
    * Dependency records from table AddOn_Dependency__c are being processed and
    * maps which will be used in AddOn Dependency engine are being populated and prepared
    *
    * Input parameters are:
    * currentlySelectedAddOnAssocIds // List of all currently selected Association AddOn Ids - { 'id1', 'id2' .. }
    *
    * Return parameters are:
    * resultMap = { allOptionalAddOnDependencies: {}, mapAssocIdRelatedDependencies: {}, allSatisfiedMandatoryAddOnDependencies: {}, allExcludedAddOnDependencies: {} };
    */


    function prepareDependencyMapsForCommercialProduct(currentlySelectedAddOnAssocIds) {
      var resultMap = {
        allMandatoryRules: {},
        allOptionalAddOnDependencies: {},
        mapAssocIdRelatedDependencies: {},
        allSatisfiedMandatoryAddOnDependencies: {},
        allExcludedAddOnDependencies: {},
        allInclusionAddOnDependencies: {},
        satisfiedInclusionAddOnDependencies: {},
        allServiceFeeRules: {}
      };
      var allSatisfiedMandatoryAddOnDependencies = {};
      var mapAssocIdRelatedDependencies = {};
      var allOptionalAddOnDependencies = {};
      var allExcludedAddOnDependencies = {};
      var allInclusionAddOnDependencies = {};
      var satisfiedInclusionAddOnDependencies = [];
      var allMandatoryRules = {};
      var allServiceFeeRules = {};
      groupMinMaxValidation = buildAssociationGroups(commercialProductAddOnAssociationListCached);
      var groupCounts = getAssociationGroupCounts(commercialProductAddOnAssociationListCached, currentlySelectedAddOnAssocIds);
      each(commercialProductAddOnAssociationListCached, function (assoc) {
        var count = groupCounts[assoc.cspmb__group__c];
        groupMinMaxValidation[assoc.cspmb__group__c].current_count = isNaN(Number(count)) ? 0 : Number(count);
      });

      if (useDependencyEngine) {
        // Preparing all inclusion records.
        allInclusionAddOnDependencies = filter_1(allDependencyRecordsCached, function (dependencyItem) {
          if (dependencyItem.type__c === 'Inclusion' && (dependencyItem.price_item__c !== undefined && dependencyItem.price_item__c === getCurrentCommercialProductId() || dependencyItem.price_item__c === undefined)) {
            return true;
          }

          return false;
        }); //if there is any campaign rules needs to be cached as mandatory rules

        allMandatoryRules = filter_1(allDependencyRecordsCached, function (dependencyItem) {
          if (dependencyItem.type__c === 'Mandatory' && (dependencyItem.price_item__c !== undefined && dependencyItem.price_item__c === getCurrentCommercialProductId() || dependencyItem.price_item__c === undefined) && (dependencyItem.campaign_promotion_source__c === undefined || dependencyItem.campaign_promotion_source__c !== undefined && dependencyItem.campaign_promotion_source__c === getCurrentCampaignPromotionId())) {
            return true;
          }

          return false;
        }); //identify all service fee related dependancy rules

        allServiceFeeRules = filter_1(allDependencyRecordsCached, function (dependencyItem) {
          if ((dependencyItem.type__c === 'Mandatory' || dependencyItem.type__c === 'Automatic Inclusion') && dependencyItem.operation__c && (dependencyItem.price_item__c !== undefined && dependencyItem.price_item__c === getCurrentCommercialProductId() || dependencyItem.price_item__c === undefined) && (dependencyItem.price_item_product_definition__c && productFamilyRule(dependencyItem, getCurrentCommercialProductDetails()) || dependencyItem.price_item_product_definition__c === undefined && dependencyItem.price_item__c !== undefined) //ServiceFee
          && (dependencyItem.campaign_promotion_source__c === undefined || dependencyItem.campaign_promotion_source__c !== undefined && dependencyItem.campaign_promotion_source__c === getCurrentCampaignPromotionId())) {
            return true;
          }

          return false;
        });

        if (currentlySelectedAddOnAssocIds.length > 0) {
          each(currentlySelectedAddOnAssocIds, function (assocId) {
            var assocRecord = mapAssocIdAssocRecord[assocId];

            if (assocRecord !== undefined) {
              each(allDependencyRecordsCached, function (dependencyItem) {
                if (dependencyItem.price_item__c !== undefined && dependencyItem.price_item__c === assocRecord.cspmb__price_item__c || dependencyItem.price_item__c === undefined) {
                  // optional group dependencies does not need to be processed within regular dependency check
                  if (dependencyItem.type__c === 'Optional' && (dependencyItem.group_source__c != undefined && dependencyItem.group_source__c !== '' || dependencyItem.add_on_source__c !== '' && dependencyItem.add_on_source__c !== undefined) && (dependencyItem.group_target__c != undefined && dependencyItem.group_target__c !== '' || dependencyItem.add_on_target__c !== '' && dependencyItem.add_on_target__c !== undefined)) {
                    if (allOptionalAddOnDependencies[assocRecord.id] === undefined) {
                      allOptionalAddOnDependencies[assocRecord.id] = [];
                    }

                    allOptionalAddOnDependencies[assocRecord.id].push(dependencyItem); // check with Marijan why this OPTIONALS are being added

                    if (dependencyItem.add_on_target__c !== undefined) {
                      if (allOptionalAddOnDependencies[dependencyItem.add_on_target__c] === undefined) {
                        allOptionalAddOnDependencies[dependencyItem.add_on_target__c] = [];
                      }

                      allOptionalAddOnDependencies[dependencyItem.add_on_target__c].push(dependencyItem);
                    }
                  } else {
                    if (dependencyItem.group_source__c !== '' && dependencyItem.group_source__c !== undefined) {
                      if (assocRecord.cspmb__group__c === dependencyItem.group_source__c) {
                        if (mapAssocIdRelatedDependencies[assocRecord.id] === undefined) {
                          mapAssocIdRelatedDependencies[assocRecord.id] = [];
                        }

                        mapAssocIdRelatedDependencies[assocRecord.id].push(dependencyItem);
                      }
                    } else if (dependencyItem.add_on_source__c !== '' && dependencyItem.add_on_source__c !== undefined) {
                      if (assocRecord.cspmb__add_on_price_item__c === dependencyItem.add_on_source__c) {
                        if (mapAssocIdRelatedDependencies[assocRecord.id] === undefined) {
                          mapAssocIdRelatedDependencies[assocRecord.id] = [];
                        }

                        mapAssocIdRelatedDependencies[assocRecord.id].push(dependencyItem);
                      }
                    } else if (dependencyItem.price_item__c !== '' && dependencyItem.price_item__c !== undefined) {
                      if (mapAssocIdRelatedDependencies[assocRecord.id] === undefined) {
                        mapAssocIdRelatedDependencies[assocRecord.id] = [];
                      }

                      mapAssocIdRelatedDependencies[assocRecord.id].push(dependencyItem);
                    } else if ((dependencyItem.add_on_source__c === undefined || dependencyItem.add_on_source__c === '') && (dependencyItem.group_source__c === undefined || dependencyItem.group_source__c === '') && dependencyItem.type__c !== 'Mandatory') {
                      if (mapAssocIdRelatedDependencies[assocRecord.id] === undefined) {
                        mapAssocIdRelatedDependencies[assocRecord.id] = [];
                      }

                      mapAssocIdRelatedDependencies[assocRecord.id].push(dependencyItem);
                    } // mandatory addon dependencies


                    if (dependencyItem.type__c === 'Mandatory' && dependencyItem.add_on_target__c != undefined && dependencyItem.add_on_target__c !== '' && (
                    /*(dependencyItem.campaign_promotion_source__c === undefined || (dependencyItem.campaign_promotion_source__c !== undefined && dependencyItem.campaign_promotion_source__c === getCurrentCampaignPromotionId())) &&*/
                    dependencyItem.add_on_target__c === assocRecord.cspmb__add_on_price_item__c || dependencyItem.add_on_source__c === assocRecord.cspmb__add_on_price_item__c)) {
                      if (allSatisfiedMandatoryAddOnDependencies[assocRecord.id] === undefined) {
                        allSatisfiedMandatoryAddOnDependencies[assocRecord.id] = [];
                      }

                      allSatisfiedMandatoryAddOnDependencies[assocRecord.id].push(dependencyItem);
                    } else if (dependencyItem.type__c === 'Exclusion') {
                      if (dependencyItem.add_on_source__c != undefined && dependencyItem.add_on_source__c !== '' && dependencyItem.add_on_source__c === assocRecord.cspmb__add_on_price_item__c) {
                        // exclusion addon dependencies
                        if (allExcludedAddOnDependencies[assocRecord.id] === undefined) {
                          allExcludedAddOnDependencies[assocRecord.id] = [];
                        }

                        allExcludedAddOnDependencies[assocRecord.id].push(dependencyItem);
                      } else if (dependencyItem.group_source__c != undefined && dependencyItem.group_source__c !== '' && dependencyItem.group_source__c === assocRecord.cspmb__group__c) {
                        // exclusion group dependencies
                        if (allExcludedAddOnDependencies[assocRecord.id] === undefined) {
                          allExcludedAddOnDependencies[assocRecord.id] = [];
                        }

                        allExcludedAddOnDependencies[assocRecord.id].push(dependencyItem);
                      } else if ((dependencyItem.add_on_source__c === undefined || dependencyItem.add_on_source__c === '') && (dependencyItem.group_source__c === undefined || dependencyItem.group_source__c === '')) {
                        if (allExcludedAddOnDependencies[assocRecord.id] === undefined) {
                          allExcludedAddOnDependencies[assocRecord.id] = [];
                        }

                        allExcludedAddOnDependencies[assocRecord.id].push(dependencyItem);
                      }
                    }
                  }
                }
              }); // Filtering records for each selected add on.

              allInclusionAddOnDependencies = filter_1(allInclusionAddOnDependencies, function (inclusionDependencyItem) {
                var isDependency = false;

                if (inclusionDependencyItem.add_on_source__c !== undefined && inclusionDependencyItem.add_on_source__c !== '' && inclusionDependencyItem.add_on_source__c === assocRecord.cspmb__add_on_price_item__c) {
                  isDependency = true;
                }

                if (inclusionDependencyItem.group_source__c !== undefined && inclusionDependencyItem.group_source__c !== '' && inclusionDependencyItem.group_source__c === assocRecord.cspmb__group__c) {
                  isDependency = true;
                }

                if (inclusionDependencyItem.group_source__c === undefined && inclusionDependencyItem.add_on_source__c === undefined) {
                  isDependency = true;
                }

                if (isDependency) {
                  satisfiedInclusionAddOnDependencies.push(inclusionDependencyItem);
                }

                return !isDependency;
              });
            }
          });
        } else {
          each(allDependencyRecordsCached, function (dependencyItem) {
            if (dependencyItem.price_item__c !== undefined && dependencyItem.price_item__c === getCurrentCommercialProductId() || dependencyItem.price_item__c === undefined) {
              if (dependencyItem.type__c === 'Inclusion' && (dependencyItem.add_on_source__c === undefined || dependencyItem.add_on_source__c === '') && (dependencyItem.group_source__c === undefined || dependencyItem.group_source__c === '')) {
                if (mapAssocIdRelatedDependencies['priceItemLevel'] === undefined) {
                  mapAssocIdRelatedDependencies['priceItemLevel'] = [];
                }

                mapAssocIdRelatedDependencies['priceItemLevel'].push(dependencyItem);
              } else if (dependencyItem.type__c === 'Exclusion') {
                if ((dependencyItem.add_on_source__c === undefined || dependencyItem.add_on_source__c === '') && (dependencyItem.group_source__c === undefined || dependencyItem.group_source__c === '')) {
                  if (allExcludedAddOnDependencies['priceItemLevel'] === undefined) {
                    allExcludedAddOnDependencies['priceItemLevel'] = [];
                  }

                  allExcludedAddOnDependencies['priceItemLevel'].push(dependencyItem);
                }
              } else if (dependencyItem.type__c === 'Automatic Inclusion') {
                if (dependencyItem.source_attribute__c !== '' && dependencyItem.source_attribute__c !== undefined) {
                  if (mapAssocIdRelatedDependencies['priceItemLevel'] === undefined) {
                    mapAssocIdRelatedDependencies['priceItemLevel'] = [];
                  }

                  mapAssocIdRelatedDependencies['priceItemLevel'].push(dependencyItem);
                }
              }
            }
          }); // Filtering records for each selected add on.

          allInclusionAddOnDependencies = filter_1(allInclusionAddOnDependencies, function (inclusionDependencyItem) {
            var isDependency = false;

            if (inclusionDependencyItem.group_source__c === undefined && inclusionDependencyItem.add_on_source__c === undefined) {
              isDependency = true;
            }

            if (isDependency) {
              satisfiedInclusionAddOnDependencies.push(inclusionDependencyItem);
            }

            return !isDependency;
          });
        }

        mapAssocIdRelatedDependencies = sortMapBySequence(mapAssocIdRelatedDependencies);
        allOptionalAddOnDependencies = sortMapBySequence(allOptionalAddOnDependencies);
        allSatisfiedMandatoryAddOnDependencies = sortMapBySequence(allSatisfiedMandatoryAddOnDependencies);
        allExcludedAddOnDependencies = sortMapBySequence(allExcludedAddOnDependencies);
        allInclusionAddOnDependencies = sortListBySequence(allInclusionAddOnDependencies);
      }

      resultMap.allOptionalAddOnDependencies = allOptionalAddOnDependencies;
      resultMap.allSatisfiedMandatoryAddOnDependencies = allSatisfiedMandatoryAddOnDependencies;
      resultMap.allExcludedAddOnDependencies = allExcludedAddOnDependencies;
      resultMap.allInclusionAddOnDependencies = allInclusionAddOnDependencies;
      resultMap.mapAssocIdRelatedDependencies = mapAssocIdRelatedDependencies;
      resultMap.satisfiedInclusionAddOnDependencies = satisfiedInclusionAddOnDependencies;
      resultMap.allMandatoryRules = allMandatoryRules;
      resultMap.allServiceFeeRules = allServiceFeeRules;
      cachedDependencyData = resultMap;
      return resultMap;
    } //ServiceFee


    function productFamilyRule(dependencyItem, currentCommercialProductIdDetails) {
      var pIProdDef;
      var pISubType;
      var text;
      var priceItemvar = {};

      if (dependencyItem.price_item_product_definition__c) {
        text = 'PriceItem';
        pIProdDef = dependencyItem.price_item_product_definition__c;

        if (dependencyItem.price_item_sub_types__c) {
          pISubType = dependencyItem.price_item_sub_types__c;
        }
      }

      priceItemvar = filter_1(currentCommercialProductIdDetails, function (pi) {
        if (text === 'PriceItem') {
          if (dependencyItem.price_item_product_definition__c && dependencyItem.price_item_sub_types__c) {
            if (dependencyItem.price_item_product_definition__c === pi.Product_Definition_Name__c && dependencyItem.price_item_sub_types__c === pi.Sub_Type__c) {
              return true;
            }
          } else if (dependencyItem.price_item_product_definition__c && dependencyItem.price_item_sub_types__c === undefined) {
            if (dependencyItem.price_item_product_definition__c === pi.Product_Definition_Name__c) return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
      return priceItemvar;
    }
    /*
    * sortMapBySequence
    *
    * Sort each list in the map based on the sequence field on the SF record.
    *
    * Input parameter: map to sort, map is association id -> list of related dependency items.
    *
    * Returns the same map with all lists sorted.
    */


    function sortMapBySequence(mapToSort) {
      // sort populated Sequence first and then undefined values
      each(mapToSort, function (listItems, key) {
        listItems = sortListBySequence(listItems);
      });
      return mapToSort;
    }
    /*
    * sortListBySequence
    *
    * Sort the list on the sequence field on the SF record.
    *
    * Input parameter: list to sort.
    *
    * Returns the sorted list.
    */


    function sortListBySequence(listToSort) {
      listToSort.sort(function (a, b) {
        if (a.sequence__c === undefined) {
          return 1;
        } else if (b.sequence__c === undefined) {
          return -1;
        } else {
          return a.sequence__c - b.sequence__c;
        }
      });
      return listToSort;
    }
    /*
    * buildAssociationGroups
    *
    * Build groups and min and max for it.
    *
    * Input parameter: associations to analyse.
    *
    * Returns the map name -> group data (min, max, count).
    */


    function buildAssociationGroups(assocs) {
      var groups = {};
      each(assocs, function (assoc) {
        var name = assoc.cspmb__group__c;
        groups[name] = {
          max_count: isNaN(Number(assoc.cspmb__max__c)) ? 1000 : Number(assoc.cspmb__max__c),
          min_count: isNaN(Number(assoc.cspmb__min__c)) ? 0 : Number(assoc.cspmb__min__c),
          current_count: 0
        };
      });
      return groups;
    }
    /*
    * getAssociationGroupCounts
    *
    * Get count of added AddOns for each related product and group.
    *
    * Input parameter: associations to analyse and currently selected asociations.
    *
    * Returns the group counts.
    */


    function getAssociationGroupCounts(assocs, selectedAddOnAssocIds) {
      var groupCounts = {};
      var assocsById = fromPairs_1(map_1(assocs, function (assoc) {
        return [assoc.id, assoc];
      }));
      each(selectedAddOnAssocIds, function (id) {
        var assoc = assocsById[id];

        if (assoc) {
          var count = groupCounts[assoc.cspmb__group__c] || (groupCounts[assoc.cspmb__group__c] = 0);
          groupCounts[assoc.cspmb__group__c] = count + 1;
        }
      });
      return groupCounts;
    }
    /*
    * preDrawAssociationListFiltering
    *
    * Performs the pre draw filtering of the available add ons baded on min-max
    * exclusion and inclusion dependencies.
    *
    * Input parameter: all selected add on association ids
    *
    * Returns the filtered list with the following information:
    * { assoc, isAvailable, unavailableReason, max, isExcluded };
    */


    function preDrawAssociationListFiltering(assocsForRelatedProduct, selectedAddOnAssocIdsForRelatedProduct, currentlySelectedAddOnAssocIdsAllRelatedProducts) {
      prepareDependencyMapsForCommercialProduct(currentlySelectedAddOnAssocIdsAllRelatedProducts);
      var groupCounts = getAssociationGroupCounts(commercialProductAddOnAssociationListCached, selectedAddOnAssocIdsForRelatedProduct);
      var excludedAddOns = getExcludedAddOns();
      var excludedGroups = getExcludedGroups();
      var mapMandatoryTargetAddOnIds = getAllMandatoryTargetAddOns();
      assocsForRelatedProduct = filter_1(assocsForRelatedProduct, function (assoc) {
        return assoc.is_active__c && assoc.cspmb__add_on_price_item__r.cspmb__is_active__c;
      });
      return map_1(assocsForRelatedProduct, function (assoc) {
        var isAvailable = true;
        var reason = '';
        var isExcluded = false;
        var grp = groupMinMaxValidation[assoc.cspmb__group__c];
        var max = grp.max_count;

        if (!checkForGroupMax(assoc, groupCounts)) {
          isAvailable = false;
          reason += 'The max for group ' + assoc.cspmb__group__c + ' has been exceeded. ';
        }

        if (useDependencyEngine) {
          if (!checkForExclusionRules(assoc, excludedAddOns, excludedGroups)) {
            isExcluded = true;
          }

          if (!checkForInclusionRules(assoc) || mapMandatoryTargetAddOnIds[assoc.cspmb__add_on_price_item__c] !== undefined) {
            isAvailable = false;
            reason += 'Add On does not satisfy the inclusion rules. ';
          }
        }

        return {
          assoc: assoc,
          isAvailable: isAvailable,
          unavailableReason: reason,
          max: max,
          isExcluded: isExcluded
        };
      });
    }
    /*
    * getExcludedAddOns
    *
    * Gets the comma separated list of excluded add on names.
    *
    * Returns the comma separated list of excluded add on names.
    */


    function getExcludedAddOns() {
      var excludedAddOns = '';
      each(cachedDependencyData.allExcludedAddOnDependencies, function (it) {
        each(it, function (i) {
          if (i.add_on_target__c != undefined) {
            // mismatch
            excludedAddOns += i.add_on_target__r.name;
            excludedAddOns += ',';
          }
        });
      });
      return excludedAddOns;
    }
    /*
    * getExcludedAddOns
    *
    * Gets the comma separated list of excluded add on names.
    *
    * Returns the comma separated list of excluded add on names.
    */


    function getExcludedGroups() {
      var excludedGroups = '';
      each(cachedDependencyData.allExcludedAddOnDependencies, function (it) {
        each(it, function (i) {
          if (i.group_target__c != undefined) {
            excludedGroups += i.group_target__c;
            excludedGroups += ',';
          }
        });
      });
      return excludedGroups;
    }

    function getMandatoryTargetAddOns() {
      var listOfMandatoryAddOnIds = {};
      each(cachedDependencyData.allSatisfiedMandatoryAddOnDependencies, function (it) {
        each(it, function (i) {
          if (i.add_on_target__c !== undefined) {
            listOfMandatoryAddOnIds[i.add_on_target__c] = i.add_on_target__c;
          }
        });
      });
      return listOfMandatoryAddOnIds;
    }

    function getAllMandatoryTargetAddOns() {
      var listOfMandatoryAddOnIds = {};
      each(cachedDependencyData.allMandatoryRules, function (it) {
        if (it.add_on_target__c !== undefined) {
          listOfMandatoryAddOnIds[it.add_on_target__c] = it.add_on_target__c;
        }
      });
      return listOfMandatoryAddOnIds;
    }
    /*
    * checkForMinMax
    *
    * Checks if the group maximum is exceeded and updates the counter data.
    *
    * Input parameter: association to check and all group counts.
    *
    * Returns false if max is exceeded, true if it is not.
    */


    function checkForGroupMax(assoc, groupCounts) {
      var grp = groupMinMaxValidation[assoc.cspmb__group__c];
      var max = grp.max_count;
      var count = groupCounts[assoc.cspmb__group__c];
      groupMinMaxValidation[assoc.cspmb__group__c].current_count = isNaN(Number(count)) ? 0 : Number(count); // mismatch

      if (count > max) {
        return false;
      }

      return true;
    }
    /*
    * checkForExclusionRules
    *
    * Checks if the add on has been included based on add on dependency inclusion rules.
    *
    * Input parameter: association to check and all excluded add ons
    * prepared in the getExcludedAddOns.
    *
    * Returns false if the add on is excluded, false if it is not.
    */


    function checkForExclusionRules(assoc, excludedAddOns, excludedGroups) {
      var excludedAddOnsList = excludedAddOns.split(',');
      var excludedGroupsList = excludedGroups.split(',');

      if (excludedAddOnsList.indexOf(assoc.cspmb__add_on_price_item__r.name) != -1 || excludedGroupsList.indexOf(assoc.cspmb__group__c) != -1) {
        return false;
      }

      return true;
    }
    /*
    * checkForInclusionRules
    *
    * Checks if the add on has been included based on add on dependency inclusion rules.
    *
    * Input parameter: association to check.
    *
    * Returns false if the add on is not included, false if it is.
    */


    function checkForInclusionRules(assoc) {
      var flag = true;
      var satisfied = false;
      each(cachedDependencyData.satisfiedInclusionAddOnDependencies, function (satisfiedInclusionDependencyItem) {
        if (satisfiedInclusionDependencyItem.add_on_target__c != undefined && satisfiedInclusionDependencyItem.add_on_target__c !== '' && satisfiedInclusionDependencyItem.add_on_target__c === assoc.cspmb__add_on_price_item__c) {
          satisfied = true;
        }

        if (satisfiedInclusionDependencyItem.group_target__c != undefined && satisfiedInclusionDependencyItem.group_target__c !== '' && satisfiedInclusionDependencyItem.group_target__c === assoc.cspmb__group__c) {
          satisfied = true;
        }
      });
      each(cachedDependencyData.allInclusionAddOnDependencies, function (inclusionDependencyItem) {
        if (inclusionDependencyItem.add_on_target__c != undefined && inclusionDependencyItem.add_on_target__c !== '' && inclusionDependencyItem.add_on_target__c === assoc.cspmb__add_on_price_item__c) {
          flag = false;
        }

        if (inclusionDependencyItem.group_target__c != undefined && inclusionDependencyItem.group_target__c !== '' && inclusionDependencyItem.group_target__c === assoc.cspmb__group__c) {
          flag = false;
        }
      });
      return satisfied || flag;
    }
    /*
    * runDependencyEngine
    *
    * Checks the add on dependencies and decides which error messages to display and add ons to add or remove
    *
    * Input parameter:
    * currentlySelectedAddOnAssocIds: list of currently selected add on association ids.
    * additionalContext: {
    *   operation: <upgrade/downgrade/change>,
    *   itemId: <if offer is getting chage/update/downgrade then target commercialProductId>,
    *   productFamily: <can be null as of now>,
    * }
    * Returns the object with following data: addOnsFromGroupToInclude, groupsToRemove, addOnsForInclusion,
    * dependentAddOnsIdToAdd, dependentAssociationsIdToAdd, dependentAddOnsIdToDelete
    * dependentAssociationsIdToDelete, groupMinMaxValidation
    */


    function runDependencyEngine(currentlySelectedAddOnAssocIds, additionalContext) {
      var contextOperation, contextItemId, contextProductFamily;

      if (!isEmpty_1(additionalContext)) {
        contextOperation = isEmpty_1(additionalContext.operation) ? contextOperation : additionalContext.operation;
        contextItemId = isEmpty_1(additionalContext.itemId) ? contextItemId : additionalContext.itemId;
        contextProductFamily = isEmpty_1(additionalContext.productFamily) ? contextProductFamily : additionalContext.productFamily;
      }

      var resultMap = {
        dependentAssociationsIdToAdd: [],
        addOnsFromGroupToInclude: [],
        groupsToRemove: [],
        addOnsToBeIncluded: {},
        dependentAddOnsIdToAdd: [],
        dependentAddOnsIdToDelete: [],
        dependentAssociationsIdToDelete: [],
        addOnsForInclusion: {},
        groupMinMaxValidation: {},
        operationToPriceItem: {},
        dependentPriceItemtoAdd: {},
        dependentPriceItemtoDelete: {}
      };

      if (useDependencyEngine) {
        var addOnsFromGroupInclusion = {};
        var groupsToRemove = [];
        var addOnsForInclusion = {};
        var dependentAddOnsIdToAdd = [];
        var dependentPriceItemtoAdd = {};
        var dependentAssociationsIdToAdd = [];
        var dependentAddOnsIdToDelete = [];
        var dependentPriceItemtoDelete = {};
        var dependentAssociationsIdToDelete = [];
        var addOnsFromGroupToInclude = [];
        var operationToPriceItem = {};
        var mapAssocIdRelatedDependencies = cachedDependencyData.mapAssocIdRelatedDependencies;
        var allOptionalAddOnDependencies = cachedDependencyData.allOptionalAddOnDependencies;
        var allSatisfiedMandatoryAddOnDependencies = cachedDependencyData.allSatisfiedMandatoryAddOnDependencies;
        var allInclusionAddOnDependencies = cachedDependencyData.allInclusionAddOnDependencies;
        var satisfiedInclusionAddOnDependencies = cachedDependencyData.satisfiedInclusionAddOnDependencies;
        var allMandatoryRules = cachedDependencyData.allMandatoryRules;
        var allServiceFeeRules = cachedDependencyData.allServiceFeeRules;
        var currentlySelectedAddOnIds = [];
        each(currentlySelectedAddOnAssocIds, function (assocId) {
          if (assocId !== undefined && assocId !== '') {
            var assocRecord = mapAssocIdAssocRecord[assocId];
            currentlySelectedAddOnIds.push(assocRecord.cspmb__add_on_price_item__c);
          }
        });
        each(allMandatoryRules, function (dependencyRule) {
          if ((dependencyRule.add_on_source__c === undefined || dependencyRule.add_on_source__c === '') && (dependencyRule.group_source__c === undefined || dependencyRule.group_source__c === '') && (dependencyRule.campaign_promotion_source__c === undefined || dependencyRule.campaign_promotion_source__c !== undefined && dependencyRule.campaign_promotion_source__c === getCurrentCampaignPromotionId())) {
            var operation = dependencyRule.operation__c;

            if (operation && !includes_1(operation, contextOperation)) {
              return;
            }

            dependentAddOnsIdToAdd.push(dependencyRule.add_on_target__c);
          }
        });
        each(allServiceFeeRules, function (dependencyRule) {
          var operationArr = dependencyRule.operation__c ? dependencyRule.operation__c.split(';') : [];
          var addOnSource = dependencyRule.add_on_source__c;
          var priceItemTarget = dependencyRule.price_item_target__c; //let priceItemTarget = dependencyRule.price_item_target__r;

          if (addOnSource) {
            each(operationArr, function (operation) {
              //operation = operation.toUpperCase().replace(/ /g,'_');
              var key = operation + ':' + addOnSource;
              var value = priceItemTarget;
              operationToPriceItem[key] = value;
            });
          } else {
            each(operationArr, function (operation) {
              //operation = operation.toUpperCase().replace(/ /g,'_');
              var key = operation;
              var value = priceItemTarget;
              operationToPriceItem[key] = value;
            });
          }
        });
        each(mapAssocIdRelatedDependencies, function (value, key) {
          each(value, function (childValue) {
            var targetGroup = childValue.group_target__c;
            var useGroupInclusionCheck = false;
            var quantity = isNaN(Number(childValue.quantity__c)) ? 1 : Number(childValue.quantity__c);
            var type = childValue.type__c;
            var addOnTarget = childValue.add_on_target__c;
            var priceItemTarget = childValue.price_item_target__c;
            var targetAddOnMissing = true;
            var targetAddOnName = '';
            var sequence = childValue.sequence__c;
            var operation = childValue.operation__c;

            if (operation && !includes_1(operation, contextOperation)) {
              return;
            } // this is check for Target AddOn only
            // mismatch


            if (type === 'Inclusion' && childValue.add_on_target__r != undefined && childValue.add_on_target__r.name !== '') {
              // check for target add on and store the name for the message
              targetAddOnName = childValue.add_on_target__r.name;
            } else {
              // no target add ons needed for add
              targetAddOnMissing = false;
              targetAddOnName = '';
            } // this is check for groups


            if (type === 'Inclusion' && targetGroup !== undefined && targetGroup !== '') {
              // check if inclusion quantity check needed for this dependency record
              useGroupInclusionCheck = true;
            }

            var childValueId = childValue.id;

            if (childValueId == undefined) {
              childValueId = childValue.Id;
            } // if it is Mandatory then search for the missing ones
            // this is for adding all the missing add ons in bulk


            if (type === 'Mandatory' || type === 'Automatic Inclusion' && !usedAutomaticInclusions.includes(childValueId)) {
              // store the Add On Id to check is already present or not
              dependentAddOnsIdToAdd.push(addOnTarget);

              if (!operation && priceItemTarget) {
                dependentPriceItemtoAdd[childValue.id] = priceItemTarget;
              } //ServiceFee map of operation vs priceItem


              if (type === 'Automatic Inclusion') {
                usedAutomaticInclusions.push(childValueId);
              }
            }

            each(currentlySelectedAddOnAssocIds, function (assocId) {
              var assocRecord = mapAssocIdAssocRecord[assocId];

              if (assocRecord !== undefined) {
                // skip assoc record for which you are checking dependencies
                // if(assocRecord.id !== key) {
                if (type === 'Inclusion') {
                  // check how many is missing from some specific group
                  // if quantity at the end is more than 0 show message
                  if (targetGroup !== undefined && targetGroup !== '' && assocRecord.cspmb__group__c === targetGroup) {
                    quantity--;
                  } else if (assocRecord.cspmb__add_on_price_item__c == addOnTarget) {
                    // this is used when user wants to add more than 1 AddOn record of the same type
                    quantity--;

                    if (quantity < 1) {
                      // enough Target Add Ons already added
                      targetAddOnMissing = false;
                    }
                  }
                } else if (type === 'Exclusion' || type === 'Automatic Deletion' && !usedAutomaticDeletions.includes(childValueId)) {
                  if (type === 'Exclusion') {
                    if (targetGroup !== undefined && targetGroup !== '' && assocRecord.cspmb__group__c === targetGroup) {
                      //if (!includes(groupsToRemove, targetGroup)) {
                      groupsToRemove.push({
                        targetGroup: targetGroup,
                        sequence: sequence
                      }); //}
                    } else if (assocRecord.cspmb__add_on_price_item__c == addOnTarget && childValue.add_on_target__r != undefined && childValue.add_on_target__r.name !== '') {
                      // this is for exclusion of add ons in bulk
                      // store the Add On Id to check is already present or not
                      if (!includes_1(dependentAddOnsIdToDelete, addOnTarget)) dependentAddOnsIdToDelete.push(addOnTarget);
                    }
                  } else {
                    if (!includes_1(dependentAddOnsIdToDelete, addOnTarget)) {
                      dependentAddOnsIdToDelete.push(addOnTarget);
                    } //if(!operation && priceItemTarget){


                    if (priceItemTarget) {
                      dependentPriceItemtoDelete[childValue.id] = priceItemTarget;
                    }
                  }
                }
              }
            });

            if (type === 'Automatic Deletion') {
              usedAutomaticDeletions.push(childValueId);
            }

            if (quantity > 0 && useGroupInclusionCheck) {
              if (addOnsFromGroupInclusion[key] === undefined) {
                addOnsFromGroupInclusion[key] = [];
              }

              addOnsFromGroupInclusion[key].push(targetGroup);
            } // target add on missing is used in Inclusion type rules


            if (targetAddOnMissing) {
              if (addOnsForInclusion[addOnTarget] === undefined) {
                addOnsForInclusion[addOnTarget] = [];
              }

              var listItem = {
                targetAddOnName: targetAddOnName,
                quantity: quantity,
                operation: operation
              };
              addOnsForInclusion[addOnTarget].push(listItem);
            }
          });
        });
        each(currentlySelectedAddOnAssocIds, function (assocId) {
          var assocRecord = mapAssocIdAssocRecord[assocId];

          if (assocRecord !== undefined) {
            if (dependentAddOnsIdToAdd.includes(assocRecord.cspmb__add_on_price_item__c)) {
              remove(dependentAddOnsIdToAdd, function (currentItem) {
                return currentItem === assocRecord.cspmb__add_on_price_item__c;
              });
            }
          }
        }); // invalidate configuration if addons from target group are missing

        each(addOnsFromGroupInclusion, function (targetGroups, assocId) {
          each(targetGroups, function (targetGroup) {
            var invalidateConfig = true; // check if this addon group has any optional records
            // if has optional records and source group is added - do not require target group

            var optionalListForAssocId = allOptionalAddOnDependencies[assocId];

            if (optionalListForAssocId !== undefined && optionalListForAssocId.length > 0) {
              each(optionalListForAssocId, function (listItem) {
                var sourceGroupOptional = listItem.group_source__c;
                var sourceAddOnOptional = listItem.add_on_source__c;
                var targetGroupOptional = listItem.group_target__c;
                var operationOptional = listItem.operation__c;

                if (operationOptional && !includes_1(operationOptional, contextOperation)) {
                  return;
                }

                if (sourceGroupOptional !== undefined && sourceGroupOptional !== '') {
                  var assocGroupState = groupMinMaxValidation[sourceGroupOptional];

                  if (assocGroupState !== undefined && targetGroup === targetGroupOptional) {
                    var currentValue = assocGroupState.current_count;

                    if (currentValue > 0) {
                      invalidateConfig = false;
                    }
                  }
                }

                if (sourceAddOnOptional !== undefined && sourceAddOnOptional !== '') {
                  each(currentlySelectedAddOnAssocIds, function (assocId) {
                    var assocRecord = mapAssocIdAssocRecord[assocId];

                    if (sourceAddOnOptional === assocRecord.cspmb__add_on_price_item__c) {
                      invalidateConfig = false;
                    }
                  });
                }
              });
            }

            if (invalidateConfig) {
              addOnsFromGroupToInclude.push(targetGroup);
            }
          });
        });
        var addOnsForInclusionFinal = {}; /// check MIN and MAX and prepare final list to return

        each(addOnsForInclusion, function (listItem, key) {
          each(mapAssocIdAssocRecord, function (assocValue, assocKey) {
            if (assocValue.cspmb__add_on_price_item__c === key) {
              var optionalListForAssocId = allOptionalAddOnDependencies[assocKey];

              if (optionalListForAssocId === undefined) {
                optionalListForAssocId = allOptionalAddOnDependencies[key];
              }

              var optional = false;

              if (optionalListForAssocId !== undefined && optionalListForAssocId.length > 0) {
                each(optionalListForAssocId, function (listItem) {
                  if (listItem.add_on_target__c === assocValue.cspmb__add_on_price_item__c && (listItem.add_on_source__c === undefined || currentlySelectedAddOnIds.includes(listItem.add_on_source__c))) {
                    optional = true;
                  }
                });
              } // check on Association level - MIN and MAX within the Group


              var assocGroupState = groupMinMaxValidation[assocValue.cspmb__group__c];

              if (assocGroupState !== undefined) {
                var maxValue = assocGroupState.max_count;
                var currentValue = assocGroupState.current_count;

                if (currentValue < maxValue && !optional) {
                  addOnsForInclusionFinal[key] = listItem;
                }
              }
            }
          });
        }); // sort groups to remove messages in sequence defined order

        groupsToRemove.sort(function (a, b) {
          if (a.sequence === undefined) {
            return 1;
          } else if (b.sequence === undefined) {
            return -1;
          } else {
            return a.sequence - b.sequence;
          }
        }); // update dependentAddOnsIdToAdd if some are not allowed to be added based on MIN and MAX
        // respect min and max for associations

        if (dependentAddOnsIdToAdd.length > 0) {
          each(mapAssocIdAssocRecord, function (assocValue, key) {
            each(dependentAddOnsIdToAdd, function (addOnId) {
              if (assocValue.cspmb__add_on_price_item__c === addOnId) {
                var assocGroupState = groupMinMaxValidation[assocValue.cspmb__group__c];

                if (assocGroupState !== undefined) {
                  var maxValue = assocGroupState.max_count;
                  var currentValue = assocGroupState.current_count;

                  if (currentValue < maxValue) {
                    dependentAssociationsIdToAdd.push(key);
                  }
                }
              }
            });
          });
        } //update dependentAddOnsIdToDelete if some are not allowed to be deleted


        if (dependentAddOnsIdToDelete.length > 0) {
          each(mapAssocIdAssocRecord, function (value, key) {
            each(dependentAddOnsIdToDelete, function (addOnId) {
              if (value.cspmb__add_on_price_item__c === addOnId && (value.cspmb__default_quantity__c === undefined || value.cspmb__default_quantity__c < 1)) {
                var assocGroupState = groupMinMaxValidation[value.cspmb__group__c];

                if (assocGroupState !== undefined) {
                  var minValue = assocGroupState.min_count;
                  var currentValue = assocGroupState.current_count;

                  if (currentValue > minValue) {
                    dependentAssociationsIdToDelete.push(key);
                  }
                }
              }
            });
          });
        } // when "parent" AddOn in Mandatory dependency between AddOn Source and AddOn Target is deleted
        // find "children" and delete them too


        each(currentlySelectedAddOnAssocIds, function (selectedAssoc) {
          // get mandatory dependency records
          var depenRecordsForAssoc = allSatisfiedMandatoryAddOnDependencies[selectedAssoc];

          if (depenRecordsForAssoc !== undefined && depenRecordsForAssoc.length > 0) {
            // if its more than just "parent" and "child"
            // this is TRUE if PARENT -> CHILD -> GRANDCHILD relationship found
            var dependenciesExist = false;
            var superDependenciesExist = true;
            var parentFound = false;
            each(depenRecordsForAssoc, function (childValue) {
              var addOnTarget = childValue.add_on_target__c;
              var addOnSource = childValue.add_on_source__c;
              var campaignSource = childValue.campaign_promotion_source__c; // if this assoc is parent to some addon

              if (addOnSource === mapAssocIdAssocRecord[selectedAssoc].cspmb__add_on_price_item__c) {
                // this assoc is parent to some addon assoc and do not allow deletion of selectedAssoc
                dependenciesExist = true;
              } // need to check if parent assoc is currently added


              var enteredInParentCheck = false; // it will enter only if selectedAssoc is "child" AddOn Assoc to other AddOn Assoc and the source of the dependency records are not the campaign Promotions

              if ((campaignSource === undefined || campaignSource === '') && addOnTarget === mapAssocIdAssocRecord[selectedAssoc].cspmb__add_on_price_item__c) {
                enteredInParentCheck = true; // trying to find parent assoc record

                each(currentlySelectedAddOnAssocIds, function (parentAssocId) {
                  var parentAssoc = mapAssocIdAssocRecord[parentAssocId];

                  if (parentAssoc.cspmb__add_on_price_item__c === addOnSource || addOnSource === undefined || addOnSource === '') {
                    parentFound = true;
                    dependenciesExist = true;
                  }
                });
              } // if this assoc is "child" of some MANDATORY relation and "parent" assoc wasnt found
              // delete this "child"


              if (enteredInParentCheck && !parentFound) {
                superDependenciesExist = false;
              } // check if "parent" is just being added in this iteration
              // skip deletion because of that
              // use case - when someone tries to delete middle AddOn in Mandatory dependency


              each(dependentAssociationsIdToAdd, function (assocIdToAdd) {
                var parentAssoc = mapAssocIdAssocRecord[assocIdToAdd];

                if (parentAssoc.cspmb__add_on_price_item__c === addOnSource) {
                  dependenciesExist = true;
                  superDependenciesExist = true;
                }
              }); // if "child" is being currently added

              each(dependentAssociationsIdToAdd, function (assocIdToAdd) {
                var childAssoc = mapAssocIdAssocRecord[assocIdToAdd];

                if (childAssoc.cspmb__add_on_price_item__c === addOnTarget) {
                  dependenciesExist = true;
                }
              }); //if campaign promotion exists then let the addon be there

              if (getCurrentCampaignPromotionId() !== undefined && getCurrentCampaignPromotionId() !== '' && childValue.campaign_promotion_source__c === getCurrentCampaignPromotionId()) dependenciesExist = true;
            });

            if (!dependenciesExist || !superDependenciesExist && !parentFound) {
              if (!includes_1(dependentAssociationsIdToDelete, selectedAssoc)) {
                dependentAssociationsIdToDelete.push(selectedAssoc);
              }
            }
          } // Delete target add ons when source is deleted (inclusion)
          // Check for inclusion add ons no longer valid.


          each(allInclusionAddOnDependencies, function (inclusionDependencyItem) {
            var satisfied = false;
            var assocRecord = mapAssocIdAssocRecord[selectedAssoc];
            each(satisfiedInclusionAddOnDependencies, function (satisfiedDependencyItem) {
              if (satisfiedDependencyItem.add_on_target__c === assocRecord.cspmb__add_on_price_item__c || satisfiedDependencyItem.group_target__c === assocRecord.cspmb__group__c) {
                satisfied = true;
              }
            });

            if (!satisfied) {
              if (inclusionDependencyItem.add_on_target__c === assocRecord.cspmb__add_on_price_item__c || inclusionDependencyItem.group_target__c === assocRecord.cspmb__group__c) {
                if (!includes_1(dependentAssociationsIdToDelete, selectedAssoc)) {
                  dependentAssociationsIdToDelete.push(selectedAssoc);
                }
              }
            }
          });
        });
        resultMap.addOnsFromGroupToInclude = addOnsFromGroupToInclude;
        resultMap.groupsToRemove = groupsToRemove; //resultMap.addOnsToBeIncluded = addOnsToBeIncluded;

        resultMap.addOnsForInclusion = addOnsForInclusionFinal;
        resultMap.dependentAddOnsIdToAdd = dependentAddOnsIdToAdd;
        resultMap.dependentAssociationsIdToAdd = dependentAssociationsIdToAdd;
        resultMap.dependentAddOnsIdToDelete = dependentAddOnsIdToDelete;
        resultMap.dependentAssociationsIdToDelete = dependentAssociationsIdToDelete;
        resultMap.operationToPriceItem = operationToPriceItem;
        resultMap.dependentPriceItemtoAdd = dependentPriceItemtoAdd;
        resultMap.dependentPriceItemtoDelete = dependentPriceItemtoDelete;
      }

      resultMap.groupMinMaxValidation = groupMinMaxValidation;
      return resultMap;
    }

    function calculateDelta(newCommercialProductId, campaignPromotionIDSelected, currentlySelectedAddOnIds, newCommercialProductAddOnAssociations, dependencyRecords, newOfferAddOnIds, isMACD) {
      var resultMap = {
        addOnsToAdd: {},
        addOnsToRemove: {},
        groupsToAdd: {},
        groupsToRemove: {},
        groupMinMax: {},
        currentlySelectedAssociationAddOnIds: {}
      };
      var addOnsToAdd = new Set();
      var addOnsToRemove = new Set();
      var groupsToAdd = new Set();
      var groupsToRemove = new Set();
      var currentlySelectedAssociationAddOnIds = [];
      var assocMap = [];
      var addOnNamesMap = [];
      each(newCommercialProductAddOnAssociations, function (assoc) {
        assocMap[assoc.id] = assoc;
        addOnNamesMap[assoc.cspmb__add_on_price_item__r.name] = assoc.cspmb__add_on_price_item__c;

        if (currentlySelectedAddOnIds.includes(assoc.cspmb__add_on_price_item__c)) {
          currentlySelectedAssociationAddOnIds.push(assoc.id);
          currentlySelectedAddOnIds.remove(assoc.cspmb__add_on_price_item__c);
        }

        if (newOfferAddOnIds.includes(assoc.cspmb__add_on_price_item__c)) {
          currentlySelectedAssociationAddOnIds.push(assoc.id);
          newOfferAddOnIds.remove(assoc.cspmb__add_on_price_item__c);
        }
      });
      each(currentlySelectedAddOnIds, function (addOnId) {
        addOnsToRemove.add(addOnId);
      });
      init(newCommercialProductId, campaignPromotionIDSelected, newCommercialProductAddOnAssociations, dependencyRecords, isMACD, true);
      var availableAddOns = preDrawAssociationListFiltering(newCommercialProductAddOnAssociations, currentlySelectedAssociationAddOnIds, currentlySelectedAssociationAddOnIds);
      var dependencyResults = runDependencyEngine(currentlySelectedAssociationAddOnIds, null);
      each(dependencyResults.dependentAssociationsIdToAdd, function (assocId) {
        addOnsToAdd.add(assocMap[assocId].cspmb__add_on_price_item__c);
      });
      each(dependencyResults.addOnsFromGroupToInclude, function (groupName) {
        groupsToAdd.add(groupName);
      });
      each(dependencyResults.groupsToRemove, function (groupName) {
        groupsToRemove.add(groupName.targetGroup);
      });
      each(dependencyResults.addOnsToBeIncluded, function (addOnId) {
        addOnsToAdd.add(addOnId);
      });
      each(dependencyResults.dependentAddOnsIdToAdd, function (addOnId) {
        addOnsToAdd.add(addOnId);
      });
      each(dependencyResults.dependentAddOnsIdToDelete, function (addOnId) {
        addOnsToRemove.add(addOnId);
      });
      each(dependencyResults.dependentAssociationsIdToDelete, function (assocId) {
        addOnsToRemove.add(assocMap[assocId].cspmb__add_on_price_item__c);
      });
      each(dependencyResults.addOnsForInclusion, function (addOnId) {
        addOnsToAdd.add(addOnNamesMap[addOnId[0].targetAddOnName]);
      });
      resultMap.addOnsToAdd = Array.from(addOnsToAdd);
      resultMap.addOnsToRemove = Array.from(addOnsToRemove);
      resultMap.groupsToAdd = Array.from(groupsToAdd);
      resultMap.groupsToRemove = Array.from(groupsToRemove);
      resultMap.groupMinMax = dependencyResults.groupMinMaxValidation;
      resultMap.currentlySelectedAssociationAddOnIds = currentlySelectedAssociationAddOnIds;
      return resultMap;
    }
    /**
     * @param allDependencyRecords
     *  dependencyRecord object array from add-on-rules API
     * @param offerTransitionPriorityMap
     *  example { "commercialProductObjectId": otpValue, "a27UD000000dB6UYAU": 90 }
     * @param sourceCommercialProductId
     *  commercialProductObjectId of the subscription from where MACD will happen
     * @param targetCommercialProductIds
     *  list of commercialProductObjectIds to which MACD is supposed to be performed
     * @returns
     *  example { "commercialProductObjectId": {
     *      priceItemId: "service-fee-product-object-id",
     *      price: serviceFeeProductOCPrice
     *    }}
     */


    function getPriceItemAndServiceFeesMap(allDependencyRecords, offerTransitionPriorityMap, sourceCommercialProductId, targetCommercialProductIds) {
      var getOperation = function getOperation(targetId) {
        var sourceOtp = offerTransitionPriorityMap[sourceCommercialProductId];
        var targetOtp = offerTransitionPriorityMap[targetId];

        if (sourceOtp === undefined || targetOtp === undefined || sourceOtp === targetOtp) {
          return 'Offer Change';
        }

        return sourceOtp - targetOtp < 0 ? 'Offer Upgrade' : 'Offer Downgrade';
      };
      /* example serviceFeeMap = {
        "commercialProductObjectId": { priceItemId: "service-fee-product-object-id", price: serviceFeeProductOCPrice },
        "a27UD000000dB6UYAU": { priceItemId: "a27UD000000dE6LYAU", price: 899 },
        "a27UD000000dB7UYAU": { priceItemId: "a27UD000000dB8UYAU", price: 399 },
      } */


      var serviceFeeMap = {}; // populate serviceFeeMap

      targetCommercialProductIds.forEach(function (targetCommercialProductId) {
        allDependencyRecords.filter(function (depRecord) {
          return depRecord.price_item__c === targetCommercialProductId;
        }).filter(function (depRecord) {
          return depRecord.price_item_target__c && depRecord.price_item_target__r && depRecord.operation__c;
        }).filter(function (depRecord) {
          return depRecord.operation__c === getOperation(targetCommercialProductId);
        }).forEach(function (depRecord) {
          var depRecordPrice = depRecord.price_item_target__r.one_off_charge_online__c || 0;
          var depRecordProductId = depRecord.price_item_target__c;
          serviceFeeMap[targetCommercialProductId] = {
            price: depRecordPrice * 100,
            priceItemId: depRecordProductId
          };
        });
      });
      return serviceFeeMap;
    }

    return {
      init: init,
      getCurrentCommercialProductId: getCurrentCommercialProductId,
      getCurrentCommercialProductDetails: getCurrentCommercialProductDetails,
      preDrawAssociationListFiltering: preDrawAssociationListFiltering,
      runDependencyEngine: runDependencyEngine,
      setCurrentCampaignPromotionId: setCurrentCampaignPromotionId,
      getCurrentCampaignPromotionId: getCurrentCampaignPromotionId,
      getMandatoryTargetAddOns: getMandatoryTargetAddOns,
      calculateDelta: calculateDelta,
      getPriceItemAndServiceFeesMap: getPriceItemAndServiceFeesMap
    };
  }

  var AddOnManagerOnline = {
    getRequiredDependencyActions: function getRequiredDependencyActions(commercialProductId, allAssociationRecords, allDependencyRecords, selectedAssociationIds, selectedCampaignPromotionId, commercialProductIdList, changeContext) {
      var addOnManager = buildAddOnManagerFunctions();
      var commercialProductAssociationRecords = allAssociationRecords.filter(function (assocRecord) {
        return assocRecord.cspmb__price_item__c === commercialProductId;
      });
      addOnManager.init(commercialProductId, selectedCampaignPromotionId, commercialProductAssociationRecords, allDependencyRecords, true, true, commercialProductIdList);
      addOnManager.preDrawAssociationListFiltering(commercialProductAssociationRecords, selectedAssociationIds, selectedAssociationIds);
      return addOnManager.runDependencyEngine(selectedAssociationIds, changeContext);
    },
    getAssociationsAvailability: function getAssociationsAvailability(commercialProductId, allAssociationRecords, allDependencyRecords, selectedAssociationIds, selectedCampaignPromotionId, commercialProductIdList) {
      var addOnManager = buildAddOnManagerFunctions();
      var commercialProductAssociationRecords = allAssociationRecords.filter(function (assocRecord) {
        return assocRecord.cspmb__price_item__c === commercialProductId;
      });
      addOnManager.init(commercialProductId, selectedCampaignPromotionId, commercialProductAssociationRecords, allDependencyRecords, true, true, commercialProductIdList);
      return addOnManager.preDrawAssociationListFiltering(commercialProductAssociationRecords, selectedAssociationIds, selectedAssociationIds);
    },
    getListOfServiceFeesByProductIds: function getListOfServiceFeesByProductIds(allDependencyRecords, offerTransitionPriorityMap, sourceCommercialProductId, targetCommercialProductIds) {
      var addOnManager = buildAddOnManagerFunctions();
      return addOnManager.getPriceItemAndServiceFeesMap(allDependencyRecords, offerTransitionPriorityMap, sourceCommercialProductId, targetCommercialProductIds);
    }
  };

  return AddOnManagerOnline;

})));
